module.exports = __webpack_public_path__ + "static/img/YinLian-Big.8ac3fc8.png";


//////////////////
// WEBPACK FOOTER
// ./static/order/YinLian-Big.png
// module id = 165
// module chunks = 18